import { firstValueFrom, Observable, ReplaySubject } from "rxjs";
import { filter } from "rxjs/operators";
import { logStateChange } from "./log";
var State = /** @class */ (function () {
    function State(source$, isNonValue, afterConnect, afterDisconnect
    /*private readonly getNonValue: () => X*/ ) {
        var _this = this;
        this.isNonValue = isNonValue;
        this.afterConnect = afterConnect;
        this.afterDisconnect = afterDisconnect;
        this.name = null;
        this.logEnabled = true;
        this.pristine = true;
        this.outputStreamTrailing = new ReplaySubject(1);
        this.observerCount = 0;
        this.timestampOfLastValue = -1;
        this.outputStream = new ReplaySubject(1);
        this.value$ = this.outputStream.pipe(filter(function (v) { return !_this.isNonValue(v); }));
        this.nonValue$ = this.outputStream.pipe(filter(function (v) { return _this.isNonValue(v); }));
        this.inputStream = source$;
        this.connect();
    }
    State.prototype.connect = function () {
        var _this = this;
        if (this.isConnected()) {
            this.disconnect();
        }
        this.sourceSubscription = this.inputStream
            .subscribe(function (val) {
            _this.setInnerValue(val);
        });
        this.afterConnect(this, this.setInnerValue.bind(this));
        return this;
    };
    State.prototype.disconnect = function () {
        // if (this.hasValue()) {
        //     this.setInnerValue(this.getNonValue());
        // }
        this.afterDisconnect(this, this.setInnerValue.bind(this));
        this.sourceSubscription && this.sourceSubscription.unsubscribe();
        this.sourceSubscription = undefined;
        this.pristine = true;
        return this;
    };
    State.prototype.isConnected = function () {
        return this.sourceSubscription !== undefined;
    };
    State.prototype.isValueOlderThan = function (timeoutInMs) {
        var ageValue = Date.now() - this.timestampOfLastValue;
        return ageValue > timeoutInMs;
    };
    /**
     * Returns true if this state has a value.
     */
    State.prototype.hasValue = function () {
        return !this.isNonValue(this.stateValue);
    };
    State.prototype.changes$ = function (reason) {
        return this.wrapObserve(this.outputStream.asObservable(), reason);
    };
    State.prototype.changesPromise = function () {
        return firstValueFrom(this.changes$());
    };
    State.prototype.values$ = function (reason) {
        return this.wrapObserve(this.value$, reason);
    };
    State.prototype.valuesPromise = function () {
        return firstValueFrom(this.values$());
    };
    State.prototype.nonValues$ = function (reason) {
        return this.wrapObserve(this.nonValue$, reason);
    };
    State.prototype.nonValuesPromise = function () {
        return firstValueFrom(this.nonValues$());
    };
    Object.defineProperty(State.prototype, "value", {
        get: function () {
            return this.stateValue;
        },
        enumerable: false,
        configurable: true
    });
    State.prototype.getValueOr = function (or) {
        return this.hasValue() ? this.value : or;
    };
    State.prototype.mapOr = function (fn, orValue) {
        if (this.hasValue()) {
            return fn(this.value);
        }
        else {
            return orValue;
        }
    };
    State.prototype.forEach = function (fn) {
        this.values$().subscribe(function (v) { return fn(v); });
        return this;
    };
    Object.defineProperty(State.prototype, "text", {
        get: function () {
            return this.hasValue() ? this.value.toString() : "";
        },
        enumerable: false,
        configurable: true
    });
    State.prototype.getSubscriberCount = function () {
        return this.observerCount;
    };
    State.prototype.hasSubscribers = function () {
        return this.getSubscriberCount() > 0;
    };
    State.prototype.onObserverSubscribed = function () {
    };
    State.prototype.onObserverUnsubscribed = function () {
    };
    State.prototype.log = function () {
        logStateChange(this);
    };
    State.prototype.setInnerValue = function (val) {
        this.stateValue = val;
        this.pristine = false;
        if (this.logEnabled) {
            this.log();
        }
        if (!this.isNonValue(val)) {
            this.timestampOfLastValue = Date.now();
        }
        else {
            this.timestampOfLastValue = -1;
        }
        this.outputStream.next(val);
        this.outputStreamTrailing.next(val);
    };
    State.prototype.wrapObserve = function ($, reason) {
        var _this = this;
        return Observable.create(function (subscriber) {
            _this.observerCount++;
            _this.onObserverSubscribed();
            var sub = $.subscribe(function (val) {
                if (reason !== undefined) {
                    // TODO
                    // this.log("-> " + reason);
                }
                subscriber.next(val);
            }, function (error) {
                subscriber.error(error);
            }, function () {
                subscriber.complete();
            });
            return function () {
                sub.unsubscribe();
                _this.observerCount--;
                _this.onObserverUnsubscribed();
            };
        });
    };
    return State;
}());
export { State };
export function observableToState(input$) {
    return new State(input$, function (x) { return x === undefined; }, function (state, setStateFn) {
        if (state.pristine) {
            setStateFn(undefined);
        }
    }, function (state, setStateFn) {
        if (state.hasValue()) {
            setStateFn(undefined);
        }
    });
}
